import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.views.SpecialLineItemView.';
  public static readonly specialItemPlural = `${Id.prefix}specialItemPlural`;
  public static readonly quantityGreaterThanZero = `${Id.prefix}quantityGreaterThanZero`;
  public static readonly title = `${Id.prefix}title`;
  public static readonly reference = `${Id.prefix}reference`;
  public static readonly quantity = `${Id.prefix}quantity`;
  public static readonly unitCost = `${Id.prefix}unitCost`;
  public static readonly totalCost = `${Id.prefix}totalCost`;
  public static readonly comment = `${Id.prefix}comment`;
  public static readonly newSpecialItem = `${Id.prefix}newSpecialItem`;
  public static readonly gettingUpdatesFromSupplier = `${Id.prefix}gettingUpdatesFromSupplier`;
  public static readonly savingItem = `${Id.prefix}savingItem`;
  public static readonly requestingUpdatesFromSupplier = `${Id.prefix}requestingUpdatesFromSupplier`;
  public static readonly supplierProcessingComplete = `${Id.prefix}supplierProcessingComplete`;
}

export class LangSpecialLineItemView {
  private constructor() {}
  public static specialItemPlural(): string {
    return interpolate(Id.specialItemPlural);
  }
  public static quantityGreaterThanZero(): string {
    return interpolate(Id.quantityGreaterThanZero);
  }
  public static title(): string {
    return interpolate(Id.title);
  }
  public static reference(): string {
    return interpolate(Id.reference);
  }
  public static quantity(): string {
    return interpolate(Id.quantity);
  }
  public static unitCost(): string {
    return interpolate(Id.unitCost);
  }
  public static totalCost(): string {
    return interpolate(Id.totalCost);
  }
  public static comment(): string {
    return interpolate(Id.comment);
  }
  public static newSpecialItem(): string {
    return interpolate(Id.newSpecialItem);
  }
  public static gettingUpdatesFromSupplier(): string {
    return interpolate(Id.gettingUpdatesFromSupplier);
  }
  public static savingItem(params: { title: string }): string {
    return interpolate(Id.savingItem, params);
  }
  public static requestingUpdatesFromSupplier(): string {
    return interpolate(Id.requestingUpdatesFromSupplier);
  }
  public static supplierProcessingComplete(): string {
    return interpolate(Id.supplierProcessingComplete);
  }
}

export class SpecialLineItemViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // Dialog Titles and Labels
    register.add(Id.specialItemPlural, "{{glossary 'special-item:plural'}}", 'Dialog title for special line item');
    register.add(Id.quantityGreaterThanZero, 'Please provide a quantity greater than 0', 'Validation for quantity > 0');
    register.add(Id.title, 'Title', 'Label for special item title');
    register.add(Id.reference, 'Reference', 'Label for special item reference');
    register.add(Id.quantity, 'Quantity', 'Label for special item quantity');
    register.add(Id.unitCost, 'Unit Cost', 'Label for special item unit cost');
    register.add(Id.totalCost, 'Total Cost', 'Label for special item total cost');
    register.add(Id.comment, 'Comment', 'Label for special item comment');
    register.add(Id.newSpecialItem, "New {{glossary 'special-item'}}", 'Default title for new special item');
    register.add(
      Id.gettingUpdatesFromSupplier,
      "getting updates from {{glossary 'supplier'}}",
      'Info for getting updates from supplier'
    );
    register.add(Id.savingItem, 'Saving {{title}}', 'Info for saving item');
    register.add(
      Id.requestingUpdatesFromSupplier,
      "Requesting Updates from {{glossary 'supplier'}}",
      'Info for requesting updates from supplier'
    );
    register.add(
      Id.supplierProcessingComplete,
      "{{glossary 'supplier'}} processing complete. + sending updates to server",
      'Info for supplier processing complete'
    );
  }
}
